export const chartColumns = [
  {
    field: 'versionNo', //
    title: '版本名',
  },
  {
    field: 'changeDate', //
    title: '变更日期',
  },
  {
    field: 'operatorName',
    title: '操作人',
  },
];
